import { INotify, IReset, NotificationActionKind } from './types'
import { VariantType } from 'notistack'

export const notify = (message: string, severity: VariantType): INotify => ({
  type: NotificationActionKind.Notify,
  payload: { message, severity }
})

export const reset = (): IReset => ({
  type: NotificationActionKind.Reset
})
